import { Check } from "lucide-react";
import { WHY, IMAGES } from "@/lib/site";

export const WhyChoose = () => {
  return (
    <section
      data-testid="why-choose"
      aria-labelledby="why-heading"
      className="py-20 md:py-28 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-700">
              Why This Care Approach
            </div>
            <h2
              id="why-heading"
              className="mt-4 font-serif text-3xl md:text-5xl leading-tight tracking-tight text-slate-900"
            >
              {WHY.heading}
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">{WHY.intro}</p>

            <ul className="mt-8 space-y-4">
              {WHY.points.map((p, i) => (
                <li
                  key={i}
                  data-testid={`why-point-${i}`}
                  className="flex gap-4 items-start"
                >
                  <div className="mt-1 h-6 w-6 rounded-full bg-blue-900 text-white flex items-center justify-center shrink-0">
                    <Check className="h-3.5 w-3.5" strokeWidth={3} />
                  </div>
                  <span className="text-slate-700 leading-relaxed">{p}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="relative">
              <div className="rounded-[2rem] overflow-hidden aspect-[5/6] border border-slate-100">
                <img
                  src={IMAGES.patientCare}
                  alt="Doctor holding patient's hand — compassionate cancer care"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="hidden md:block absolute -left-6 top-10 bg-white rounded-2xl shadow-xl border border-slate-100 p-4 max-w-[220px]">
                <div className="text-xs uppercase tracking-widest text-blue-700 font-semibold">
                  Care Philosophy
                </div>
                <div className="mt-2 font-serif text-lg text-slate-900 leading-snug">
                  Clarity, coordination, careful planning.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
